import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import { Control } from '../../../../vas/business-objects/control/control.model';
import { Group } from '../../../../vas/business-objects/group/group.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const controlFormSubmitReducer = (
    state = initialState,
    action: actions.ControlFormSubmit
): State => {
    const control = action.payload.control;
    if (!control) {
        return state;
    }
    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            controls: arrayPushUnique(state.dirtyIds.controls, control.id),
            groups: arrayPushUnique(state.dirtyIds.groups, control.group)
        },
        control: {
            ...state.control,
            ids: [
                ...state.control.ids
                    .filter(id => id !== action.payload.control.id),
                action.payload.control.id
            ],
            entities: {
                ...state.control.entities,
                [state.controlForm.control.id]: (() => {

                    // if the control exists
                    const sequence = state.control.ids
                        .find(id => action.payload.control.id === id) ?
                        // use the current value for sequence
                        action.payload.control.sequence :
                        // else calculate the next sequence value
                        (state.control.ids
                            .map(id => state.control.entities[id])
                            .filter(c => c.group === state.group.selected)
                            .sort((a, b) => a.sequence - b.sequence)
                            .pop() || {sequence: 0})
                            .sequence + 1;

                    return new Control({
                        ...action.payload.control,
                        sequence
                    });
                })()
            }
        },
        group: {
            ...state.group,
            entities: {
                ...state.group.entities,
                [control.group]: (() => {
                    const origGroup = state.group.entities[control.group];
                    return new Group({
                        ...origGroup,
                        controls: [...origGroup.controls, control.id]
                    });
                })()
            }
        },
        controlForm: {
            control: undefined
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/control-form-submit.reducer.ts